var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGsPrintWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "description_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.476,
    height: 36.476,
    viewBox: "0 0 36.476 36.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16657",
    "data-name": "Path 16657",
    d: "M0,0H36.476V36.476H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16658",
    "data-name": "Path 16658",
    d: "M9.209,20.233H19.628v2.6H9.209Zm0-5.209H19.628v2.6H9.209ZM17.023,2H6.6A2.612,2.612,0,0,0,4,4.6V25.442a2.6,2.6,0,0,0,2.592,2.6H22.233a2.612,2.612,0,0,0,2.6-2.6V9.814Zm5.209,23.442H6.6V4.6h9.116v6.512h6.512Z",
    transform: "translate(3.819 3.214)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsPrintWhiteIcon);
export default __webpack_public_path__ + "static/media/gs-print-whiteIcon.9987ca77b15253327167033f20f83a24.svg";
export { ForwardRef as ReactComponent };